<template>
    <section class="general-modal">
        <h1>Contact</h1>
        <p>Testaankoop, <br> Hollandstraat 13, <br> 1060 Brussel</p>
        <h2>Abonnementendienst:</h2>
        <p>02 542 32 00 <br>
            van maandag tot vrijdag van 9 tot 12.30 <br>
            uur en van 13 tot 17 uur (vrijdag tot 16 uur)
        </p>
    </section>
</template>

<script>
export default {
    name: "ContactModal"
}
</script>

<style scoped>

</style>
